import { Action } from 'redux'
import initialStore from './initialStore'
import { WidgetActions } from './actionNames'
import { AuthorizationActions } from '../userAccount/actionNames'

export default function(
  store: Readonly<IWidgetStore> = initialStore,
  action: Action & any,
): IWidgetStore {
  switch (action.type) {
    case AuthorizationActions.SignOffTheAccount:
      return {
        ...initialStore,
      }
    case WidgetActions.SetWidgetType:
      return {
        ...store,
        type: action.widgetType,
      }
    case WidgetActions.WidgetsSettingsAccepted:
      return {
        ...store,
        settings: action.settings[0],
        error: action.settings.error,
      }
    case WidgetActions.WidgetsSettingsRiseError:
      return {
        ...store,
        error: true,
      }
    case WidgetActions.GoogleHotelStatusAccepted:
      return {
        ...store,
        ghotelstatus: action.settings,
      }
    case WidgetActions.GoogleHotelAccepted:
      return {
        ...store,
        ghotel: action.settings,
      }
    case WidgetActions.ToggleGHotelModal:
      return {
        ...store,
        ghotelModal: action.payload,
      }
    case 'clear widget error':
      return {
        ...store,
        error: false,
      }

    default:
      return store
  }
}

export interface IWidgetStore {
  type: WidgetType
  error?: boolean
  settings: IWidgetSettings
  ghotel: any
  ghotelModal: boolean
  ghotelstatus: any
}

export interface IWidgetSettings {
  api_key?: string
  feeding_option: boolean
  feeding_option_bb: boolean
  feeding_option_fb: boolean
  feeding_option_hb: boolean
  show_calendar: boolean
  no_reservation_online: boolean
  hide_url: boolean
  kids_price: boolean
  color: string
  policy_text: string
  lang: string
  policy_url: string
  regulation_text: string
  regulation_url: string
  subdomain: string
  block_reservations: boolean
  policy_radio: 'policy_url' | 'policy_text'
  regulation_radio: 'regulation_url' | 'regulation_text'
}

enum WidgetType {
  One = 'typeone',
  Two = 'typetwo',
  Three = 'typethree',
}
